import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// ── BG ──────────────────────────────────────────────────────────────────────
import bgCommon from './locales/bg/common.json';
import bgNav from './locales/bg/nav.json';
import bgAuth from './locales/bg/auth.json';
import bgHome from './locales/bg/home.json';
import bgSalon from './locales/bg/salon.json';
import bgBooking from './locales/bg/booking.json';
import bgEmployee from './locales/bg/employee.json';
import bgSearch from './locales/bg/search.json';
import bgDashboard from './locales/bg/dashboard.json';
import bgReviews from './locales/bg/reviews.json';
import bgLocation from './locales/bg/location.json';
import bgDatetime from './locales/bg/datetime.json';
import bgLegal from './locales/bg/legal.json';
import bgMisc from './locales/bg/misc.json';

// ── EN ──────────────────────────────────────────────────────────────────────
import enCommon from './locales/en/common.json';
import enNav from './locales/en/nav.json';
import enAuth from './locales/en/auth.json';
import enHome from './locales/en/home.json';
import enSalon from './locales/en/salon.json';
import enBooking from './locales/en/booking.json';
import enEmployee from './locales/en/employee.json';
import enSearch from './locales/en/search.json';
import enDashboard from './locales/en/dashboard.json';
import enReviews from './locales/en/reviews.json';
import enLocation from './locales/en/location.json';
import enDatetime from './locales/en/datetime.json';
import enLegal from './locales/en/legal.json';
import enMisc from './locales/en/misc.json';

// ── RU ──────────────────────────────────────────────────────────────────────
import ruCommon from './locales/ru/common.json';
import ruNav from './locales/ru/nav.json';
import ruAuth from './locales/ru/auth.json';
import ruHome from './locales/ru/home.json';
import ruSalon from './locales/ru/salon.json';
import ruBooking from './locales/ru/booking.json';
import ruEmployee from './locales/ru/employee.json';
import ruSearch from './locales/ru/search.json';
import ruDashboard from './locales/ru/dashboard.json';
import ruReviews from './locales/ru/reviews.json';
import ruLocation from './locales/ru/location.json';
import ruDatetime from './locales/ru/datetime.json';
import ruLegal from './locales/ru/legal.json';
import ruMisc from './locales/ru/misc.json';

const STORAGE_KEY = 'salonite365_lang';

const getSavedLanguage = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) || 'bg';
  } catch {
    return 'bg';
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      bg: {
        common: bgCommon,
        nav: bgNav,
        auth: bgAuth,
        home: bgHome,
        salon: bgSalon,
        booking: bgBooking,
        employee: bgEmployee,
        search: bgSearch,
        dashboard: bgDashboard,
        reviews: bgReviews,
        location: bgLocation,
        datetime: bgDatetime,
        legal: bgLegal,
        misc: bgMisc,
      },
      en: {
        common: enCommon,
        nav: enNav,
        auth: enAuth,
        home: enHome,
        salon: enSalon,
        booking: enBooking,
        employee: enEmployee,
        search: enSearch,
        dashboard: enDashboard,
        reviews: enReviews,
        location: enLocation,
        datetime: enDatetime,
        legal: enLegal,
        misc: enMisc,
      },
      ru: {
        common: ruCommon,
        nav: ruNav,
        auth: ruAuth,
        home: ruHome,
        salon: ruSalon,
        booking: ruBooking,
        employee: ruEmployee,
        search: ruSearch,
        dashboard: ruDashboard,
        reviews: ruReviews,
        location: ruLocation,
        datetime: ruDatetime,
        legal: ruLegal,
        misc: ruMisc,
      },
    },
    lng: getSavedLanguage(),
    fallbackLng: 'bg',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
  });

// Persist language choice whenever it changes
i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem(STORAGE_KEY, lng);
    document.documentElement.lang = lng;
  } catch {
    // localStorage blocked — silently ignore
  }
});

// Set initial lang attribute
document.documentElement.lang = getSavedLanguage();

export default i18n;

// Helper: map language to date locale string
export const getDateLocale = (lng) => {
  const map = { bg: 'bg-BG', en: 'en-GB', ru: 'ru-RU' };
  return map[lng] || 'bg-BG';
};

// Helper: format a date using the active language
export const formatDate = (date, options = {}, lng = i18n.language) => {
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString(getDateLocale(lng), options);
};